import { render, staticRenderFns } from "./ViewTestQuestionsCompiler.vue?vue&type=template&id=27c5cec1&scoped=true"
import script from "./ViewTestQuestionsCompiler.vue?vue&type=script&lang=js"
export * from "./ViewTestQuestionsCompiler.vue?vue&type=script&lang=js"
import style0 from "./ViewTestQuestionsCompiler.vue?vue&type=style&index=0&id=27c5cec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c5cec1",
  null
  
)

export default component.exports